export const generateParamBody = (
  level: string,
  selectedItem: any,
  platform: string
) => {
  let params: any = [];

  switch (platform) {
    case "google":
      switch (level) {
        case "keyword":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.adset_id,
                concept_name: eachselectedItem?.adset,
              },
            });
          });
          break;
        case "adset":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.campaign_id,
                concept_name: eachselectedItem?.campaign,
              },
            });
          });
          break;
        case "campaign":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
         case "ad":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.adset_id,
                concept_name: eachselectedItem?.adset,
              },
            });
          });
          break;
        default:
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
      }
      break;
    case "facebook":
      switch (level) {
        case "ad":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.adset_id,
                concept_name: eachselectedItem?.adset,
              },
            });
          });
          break;
        case "adset":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.campaign_id,
                concept_name: eachselectedItem?.campaign,
              },
            });
          });
          break;
        case "campaign":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
        default:
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
      }
      break;
    case "bing":
      switch (level) {
        case "keyword":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.adset_id,
                concept_name: eachselectedItem?.adset,
              },
            });
          });
          break;
        case "adset":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {
                concept_id: eachselectedItem?.campaign_id,
                concept_name: eachselectedItem?.campaign,
              },
            });
          });
          break;
        case "campaign":
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
        default:
          selectedItem.forEach((eachselectedItem: any) => {
            params.push({
              concept_id: eachselectedItem?.name_id,
              concept_name: eachselectedItem?.name,
              parent: {},
            });
          });
          break;
      }
      break;
    case "linkedin":
      selectedItem.forEach((eachselectedItem: any) => {
        params.push({
          concept_id: eachselectedItem?.name_id,
          concept_name: eachselectedItem?.name,
          parent: {},
        });
      });
      break;

    default:
      selectedItem.forEach((eachselectedItem: any) => {
        params.push({
          concept_id: eachselectedItem?.name_id,
          concept_name: eachselectedItem?.name,
          parent: {},
        });
      });
      break;
  }

  return params;
};
